import * as React from 'react';
import { useTranslation } from '@lib/useTypedTranslation';
import styled from 'styled-components';

import { InvalidPage } from '../components/errors/invalidPage';
import { useWorldRoutes } from './parts/allWorldRoutes';
import { useCallback, useMemo } from 'react';
import { usePathBasedQueryString } from '@lib/usePathBasedQueryString';
import { CoreAccessPointPerformance } from '../containers/core/accessPoint';
import { useWorldRequest } from '../lib/useWorldRequest';
import { getAccessPointInfo } from '../services/core/accessPoints';
import { RequestInitWithRetry } from '../lib/request';
import { Loading } from '../components/loading/loading';

const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 200px;
  justify-content: center;
`;

export const CoreAccessPointRoute = () => {
  const { queryString: search } = usePathBasedQueryString(/\/core\/accessPoints/);
  const searchParams = useMemo(() => new URLSearchParams(search), [search]);
  const id = searchParams.get('id');
  const routes = useWorldRoutes();
  const { t } = useTranslation('redirect');

  const accessPointNotFound = <InvalidPage
    message={t('ACCESS_POINT_NOT_FOUND', { ns: 'redirect' })}
    redirect={{
      message: t('REDIRECT_TO_ACCESS_POINT', { ns: 'redirect' }),
      path: routes.core.accessPoints
    }}
  />;

  const dataFetcher = useCallback(() => {
    return (options: RequestInitWithRetry) => {
      return getAccessPointInfo({ id })(options);
    };
  }, [id]);

  const {
    loading: dataLoading,
    data: info
  } = useWorldRequest(dataFetcher, { initialLoading: true });

  if (!dataLoading && (!id || !info)) {
    return accessPointNotFound;
  }

  if (dataLoading) {
    return <LoadingContainer><Loading isLoading={dataLoading} transparentOverlay={false} /></LoadingContainer>;
  }

  const accessPoint = info;

  return (
    <CoreAccessPointPerformance
      id={accessPoint.id}
      bssid={accessPoint.bssid}
      ssid={accessPoint.ssid}
      frequency={accessPoint.frequency}
    />
  );
};
